import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../base';


/**
 * Base component for LLD table data.
 */
@Component({
	selector: 'base-lld-table',
	templateUrl: './base-lld-table.component.html',	changeDetection: ChangeDetectionStrategy.Eager

})
export class BaseLldTableComponent extends BaseComponent {

	/**
	* Get Limb Lenght Discrepancy measure of long leg.
	*/
	get longlegLLD(): string {
		return this.calculateLLD(this.defAPMeasures?.def_ap_fullLength, this.defCLMeasures?.def_ap_fullLength_ctrlateral);
	}

	/**
	* Get Limb Lenght Discrepancy measure of femur.
	*/
	get femurLLD(): string {
		return this.calculateLLD(this.defAPMeasures?.def_ap_femurLength, this.defCLMeasures?.def_ap_femurLength_ctrlateral);
	}

	/**
	* Get Limb Lenght Discrepancy measure of tibia.
	*/
	get tibiaLLD(): string {
		return this.calculateLLD(this.defAPMeasures?.def_ap_tibiaLength, this.defCLMeasures?.def_ap_tibiaLength_ctrlateral);
	}

	/**
	* Get True Lenght measure.
	*/
	get trueLength(): number | undefined {
		return this.defAPMeasures?.def_ap_femurLength && this.defAPMeasures.def_ap_tibiaLength ? this.defAPMeasures.def_ap_femurLength + this.defAPMeasures.def_ap_tibiaLength : undefined;
	}

	/**
	* Get True Lenght measure of Contralateral.
	*/
	get trueLengthCL(): number | undefined {
		return this.defCLMeasures?.def_ap_femurLength_ctrlateral && this.defCLMeasures.def_ap_tibiaLength_ctrlateral ? this.defCLMeasures.def_ap_femurLength_ctrlateral + this.defCLMeasures.def_ap_tibiaLength_ctrlateral : undefined;
	}

	/**
	* Get True Lenght measure of Limb Lenght Discrepancy.
	*/
	get trueLengthLLD(): string {
		return this.calculateLLD(this.trueLength, this.trueLengthCL);
	}

	protected calculateLLD(length?: number, cl_length?: number): string {
		if (length && cl_length) {
			const lld = length - cl_length;
			let sign = null;
			if (lld > 0) sign = this.labels().LLD_TABLE_LONG;
			if (lld < 0) sign = this.labels().LLD_TABLE_SHORT;
			return sign ? `${Math.abs(lld)} ${sign}` : `${lld}`;
		}
		return '';
	}

}
